import { useState, useEffect, useCallback } from 'react'

export const useScrollBehavior = () => {
  const [scrollY, setScrollY] = useState(0)
  const [prevScrollY, setPrevScrollY] = useState(0)
  const [isHeroVisible, setIsHeroVisible] = useState(true)
  const [showFloatingSearch, setShowFloatingSearch] = useState(false)
  const [isMobile, setIsMobile] = useState(false)
  const [lastChangeTime, setLastChangeTime] = useState(0)

  // Check if device is mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768)
    }
    
    checkMobile()
    window.addEventListener('resize', checkMobile)
    
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  // Simplified scroll handler - no more flickering
  const handleScroll = useCallback(() => {
    const currentScrollY = window.scrollY
    setScrollY(currentScrollY)

    // Only apply scroll behavior on mobile
    if (!isMobile) {
      setIsHeroVisible(true)
      setShowFloatingSearch(false)
      return
    }

    const topThreshold = 120 // When to consider "at top"
    const isNearTop = currentScrollY < topThreshold
    const now = Date.now()
    const timeSinceLastChange = now - lastChangeTime

    // Only change state if enough time has passed to prevent flickering
    if (timeSinceLastChange > 100) {
      if (isNearTop && (!isHeroVisible || showFloatingSearch)) {
        setIsHeroVisible(true)
        setShowFloatingSearch(false)
        setLastChangeTime(now)
      } else if (!isNearTop && (isHeroVisible || !showFloatingSearch)) {
        setIsHeroVisible(false)
        setShowFloatingSearch(true)
        setLastChangeTime(now)
      }
    }

    setPrevScrollY(currentScrollY)
  }, [prevScrollY, isMobile, isHeroVisible, showFloatingSearch, lastChangeTime])

  // Throttle scroll events for smooth performance
  useEffect(() => {
    let timeoutId = null
    
    const throttledHandler = () => {
      if (timeoutId === null) {
        timeoutId = setTimeout(() => {
          handleScroll()
          timeoutId = null
        }, 50) // Reduced frequency for smoother behavior
      }
    }

    window.addEventListener('scroll', throttledHandler, { passive: true })
    
    return () => {
      window.removeEventListener('scroll', throttledHandler)
      if (timeoutId) {
        clearTimeout(timeoutId)
      }
    }
  }, [handleScroll])

  return {
    isHeroVisible,
    showFloatingSearch,
    isMobile,
    scrollY
  }
} 